// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Onglet Consultation PRESTATAIRE-BC (V2). Ne porte QUE les classes presta sans equivalent
   acheteur (bandeau expiration, bandeau de statut read-only, message inline, rangee d'actions).
   Le rendu des tables d'articles, totaux, sections et accordeons vient des feuilles generiques
   partagees (OperationConsultationBC.css importe ici + globals) + du scope .scbc de
   SuiviDeCommandeBCV2.css, pour une parite VISUELLE exacte avec la case acheteur operation-bc.
   Palette fermee du design system : headers #595959, orange #f97316, texte #374151. */

/* Encart expiration */
.cmd-consultation__expired-notice {
  background-color: #fee;
  border: 2px solid #c33;
  border-radius: 8px;
  padding: 16px;
  margin-bottom: 8px;
  color: #c33;
  font-weight: bold;
  text-align: center;
}

/* Bandeau de statut presta read-only */
.cmd-consultation__status {
  border-radius: 8px;
  padding: 1rem 1.25rem;
  font-weight: 600;
  font-size: 1.4rem;
}

.cmd-consultation__status--accepted {
  background-color: #ecfdf5;
  color: #047857;
  border: 1px solid #6ee7b7;
}

.cmd-consultation__status--refused {
  background-color: #fef2f2;
  color: #b91c1c;
  border: 1px solid #fca5a5;
}

.cmd-consultation__status--expired {
  background-color: #fff7ed;
  color: #c2410c;
  border: 1px solid #fdba74;
}

.cmd-consultation__status--waiting {
  background-color: #eff6ff;
  color: #1d4ed8;
  border: 1px solid #93c5fd;
}

/* Rangee d'actions */
.cmd-consultation__actions {
  display: flex;
  flex-wrap: wrap;
  gap: 1rem;
  justify-content: flex-end;
  margin-top: 0.5rem;
}

/* Message inline (remplace alert) */
.cmd-consultation__inline-message {
  border-radius: 6px;
  padding: 0.75rem 1rem;
  font-size: 1.3rem;
}

.cmd-consultation__inline-message--error {
  background-color: #fef2f2;
  color: #b91c1c;
  border: 1px solid #fca5a5;
}

.cmd-consultation__inline-message--success {
  background-color: #ecfdf5;
  color: #047857;
  border: 1px solid #6ee7b7;
}

/* ─────────────────────────────────────────────────────────────────────────────
   Descriptif (Administratif + Procedural) de la consultation BC.
   ISOLE de MS : ces regles sont une COPIE des classes .opms__* de la page MS
   (SuiviOperationMSV2.css), renommees en .bcc-desc* pour que BC ne depende PAS de
   la feuille MS. Grille 12 colonnes, sous-sections titrees, champs lecture seule
   alignes sur .input-inactif. Palette du design system.
   ───────────────────────────────────────────────────────────────────────────── */
.bcc-desc__sous-section {
  margin-bottom: 2.4rem;
}

.bcc-desc__sous-section:last-child {
  margin-bottom: 0;
}

.bcc-desc__sous-section-titre {
  font-size: 2rem;
  font-weight: 700;
  color: #000;
  margin: 0 0 1.2rem;
  padding-bottom: 0.6rem;
}

/* Grille 12 colonnes (fidele au PDF : rangees de 3 / 4 / 2 champs via les spans inline). */
.bcc-desc__grid {
  display: grid;
  grid-template-columns: repeat(12, 1fr);
  gap: 1.2rem 2rem;
  align-items: start;
}

@media (max-width: 900px) {
  .bcc-desc__grid > * {
    grid-column: 1 / -1 !important;
  }
}

/* Champs lecture seule a la meme taille/box-model que MS. On NE surcharge PAS la couleur (comme MS)
   -> le texte reste #6b7280 (global .input-inactif). */
.bcc-desc__grid .form-group .input-inactif {
  width: 100%;
  box-sizing: border-box;
  padding: 1.2rem;
  border-radius: 10px;
  font: inherit;
  line-height: 1.4;
  min-height: 4.6rem;
  border: 1px solid transparent;
}

/* Padding des sections identique a MS (4rem), scope a la consultation BC. */
.consultation-bc .section-pliable-content {
  padding: 4rem;
}

/* Cahier des charges / besoin en lecture seule : hauteur mini + retours a la ligne conserves. */
.bcc-desc__besoin-readonly {
  min-height: 8rem;
  white-space: pre-wrap;
}

/* Carte "liste des pieces" a droite des documents de consultation (trailingCard DocumentsList).
   Copie ISOLEE de .opms__docs-consultation-champ* (feuille MS), renommee en .bcc-desc__docs-champ*. */
.bcc-desc__docs-champ {
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  min-height: 88px;
  border: 1px solid #e5e7eb;
  border-radius: 0.75rem;
  background: rgba(215, 217, 217, 0.2);
  overflow: hidden;
}

.bcc-desc__docs-champ-label {
  flex-shrink: 0;
  padding: 1rem 1.25rem 0.4rem;
  color: #595959;
  font-size: 1.3rem;
  font-weight: 600;
  line-height: 1.3;
}

.bcc-desc__docs-champ-inner {
  flex: 1 1;
  min-height: 0;
  overflow: auto;
  padding: 0 1.25rem 1.125rem;
  color: #374151;
  line-height: 1.4;
  white-space: pre-wrap;
}

/* Documentation technique (lecture seule) : meme correction d'alignement que la case acheteur
   (\`.bcadm-desc__doc-technique\`, DescriptifAdministratifBC.css). Les 3 champs partagent une rangee et
   « Liste des pièces éventuelles composant la documentation technique » tient sur 2 lignes : sans ca,
   son cadre descend et se desaligne des deux autres.
   Classe modificatrice \`--doc\` : ce fichier compte 5 grilles \`.bcc-desc__grid\`, seule celle-ci est visee. */
.bcc-desc__grid--doc {
  align-items: stretch;
}
.bcc-desc__grid--doc .form-group {
  display: flex;
  flex-direction: column;
}
.bcc-desc__grid--doc .form-group .input-inactif {
  margin-top: auto;
}
`, "",{"version":3,"sources":["webpack://./src/pages/SuiviDeCommandeBCV2/components/CommandeConsultation.css"],"names":[],"mappings":"AAAA;;;;;sFAKsF;;AAEtF,sBAAsB;AACtB;EACE,sBAAsB;EACtB,sBAAsB;EACtB,kBAAkB;EAClB,aAAa;EACb,kBAAkB;EAClB,WAAW;EACX,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA,uCAAuC;AACvC;EACE,kBAAkB;EAClB,qBAAqB;EACrB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,yBAAyB;AAC3B;;AAEA,qBAAqB;AACrB;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA,oCAAoC;AACpC;EACE,kBAAkB;EAClB,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;;;;;;kFAMkF;AAClF;EACE,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA,2FAA2F;AAC3F;EACE,aAAa;EACb,sCAAsC;EACtC,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE;IACE,8BAA8B;EAChC;AACF;;AAEA;uDACuD;AACvD;EACE,WAAW;EACX,sBAAsB;EACtB,eAAe;EACf,mBAAmB;EACnB,aAAa;EACb,gBAAgB;EAChB,kBAAkB;EAClB,6BAA6B;AAC/B;;AAEA,4EAA4E;AAC5E;EACE,aAAa;AACf;;AAEA,gGAAgG;AAChG;EACE,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;sGACsG;AACtG;EACE,sBAAsB;EACtB,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,oCAAoC;EACpC,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,4BAA4B;EAC5B,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,SAAO;EACP,aAAa;EACb,cAAc;EACd,2BAA2B;EAC3B,cAAc;EACd,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;;;;4GAI4G;AAC5G;EACE,oBAAoB;AACtB;AACA;EACE,aAAa;EACb,sBAAsB;AACxB;AACA;EACE,gBAAgB;AAClB","sourcesContent":["/* Onglet Consultation PRESTATAIRE-BC (V2). Ne porte QUE les classes presta sans equivalent\n   acheteur (bandeau expiration, bandeau de statut read-only, message inline, rangee d'actions).\n   Le rendu des tables d'articles, totaux, sections et accordeons vient des feuilles generiques\n   partagees (OperationConsultationBC.css importe ici + globals) + du scope .scbc de\n   SuiviDeCommandeBCV2.css, pour une parite VISUELLE exacte avec la case acheteur operation-bc.\n   Palette fermee du design system : headers #595959, orange #f97316, texte #374151. */\n\n/* Encart expiration */\n.cmd-consultation__expired-notice {\n  background-color: #fee;\n  border: 2px solid #c33;\n  border-radius: 8px;\n  padding: 16px;\n  margin-bottom: 8px;\n  color: #c33;\n  font-weight: bold;\n  text-align: center;\n}\n\n/* Bandeau de statut presta read-only */\n.cmd-consultation__status {\n  border-radius: 8px;\n  padding: 1rem 1.25rem;\n  font-weight: 600;\n  font-size: 1.4rem;\n}\n\n.cmd-consultation__status--accepted {\n  background-color: #ecfdf5;\n  color: #047857;\n  border: 1px solid #6ee7b7;\n}\n\n.cmd-consultation__status--refused {\n  background-color: #fef2f2;\n  color: #b91c1c;\n  border: 1px solid #fca5a5;\n}\n\n.cmd-consultation__status--expired {\n  background-color: #fff7ed;\n  color: #c2410c;\n  border: 1px solid #fdba74;\n}\n\n.cmd-consultation__status--waiting {\n  background-color: #eff6ff;\n  color: #1d4ed8;\n  border: 1px solid #93c5fd;\n}\n\n/* Rangee d'actions */\n.cmd-consultation__actions {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 1rem;\n  justify-content: flex-end;\n  margin-top: 0.5rem;\n}\n\n/* Message inline (remplace alert) */\n.cmd-consultation__inline-message {\n  border-radius: 6px;\n  padding: 0.75rem 1rem;\n  font-size: 1.3rem;\n}\n\n.cmd-consultation__inline-message--error {\n  background-color: #fef2f2;\n  color: #b91c1c;\n  border: 1px solid #fca5a5;\n}\n\n.cmd-consultation__inline-message--success {\n  background-color: #ecfdf5;\n  color: #047857;\n  border: 1px solid #6ee7b7;\n}\n\n/* ─────────────────────────────────────────────────────────────────────────────\n   Descriptif (Administratif + Procedural) de la consultation BC.\n   ISOLE de MS : ces regles sont une COPIE des classes .opms__* de la page MS\n   (SuiviOperationMSV2.css), renommees en .bcc-desc* pour que BC ne depende PAS de\n   la feuille MS. Grille 12 colonnes, sous-sections titrees, champs lecture seule\n   alignes sur .input-inactif. Palette du design system.\n   ───────────────────────────────────────────────────────────────────────────── */\n.bcc-desc__sous-section {\n  margin-bottom: 2.4rem;\n}\n\n.bcc-desc__sous-section:last-child {\n  margin-bottom: 0;\n}\n\n.bcc-desc__sous-section-titre {\n  font-size: 2rem;\n  font-weight: 700;\n  color: #000;\n  margin: 0 0 1.2rem;\n  padding-bottom: 0.6rem;\n}\n\n/* Grille 12 colonnes (fidele au PDF : rangees de 3 / 4 / 2 champs via les spans inline). */\n.bcc-desc__grid {\n  display: grid;\n  grid-template-columns: repeat(12, 1fr);\n  gap: 1.2rem 2rem;\n  align-items: start;\n}\n\n@media (max-width: 900px) {\n  .bcc-desc__grid > * {\n    grid-column: 1 / -1 !important;\n  }\n}\n\n/* Champs lecture seule a la meme taille/box-model que MS. On NE surcharge PAS la couleur (comme MS)\n   -> le texte reste #6b7280 (global .input-inactif). */\n.bcc-desc__grid .form-group .input-inactif {\n  width: 100%;\n  box-sizing: border-box;\n  padding: 1.2rem;\n  border-radius: 10px;\n  font: inherit;\n  line-height: 1.4;\n  min-height: 4.6rem;\n  border: 1px solid transparent;\n}\n\n/* Padding des sections identique a MS (4rem), scope a la consultation BC. */\n.consultation-bc .section-pliable-content {\n  padding: 4rem;\n}\n\n/* Cahier des charges / besoin en lecture seule : hauteur mini + retours a la ligne conserves. */\n.bcc-desc__besoin-readonly {\n  min-height: 8rem;\n  white-space: pre-wrap;\n}\n\n/* Carte \"liste des pieces\" a droite des documents de consultation (trailingCard DocumentsList).\n   Copie ISOLEE de .opms__docs-consultation-champ* (feuille MS), renommee en .bcc-desc__docs-champ*. */\n.bcc-desc__docs-champ {\n  box-sizing: border-box;\n  display: flex;\n  flex-direction: column;\n  min-height: 88px;\n  border: 1px solid #e5e7eb;\n  border-radius: 0.75rem;\n  background: rgba(215, 217, 217, 0.2);\n  overflow: hidden;\n}\n\n.bcc-desc__docs-champ-label {\n  flex-shrink: 0;\n  padding: 1rem 1.25rem 0.4rem;\n  color: #595959;\n  font-size: 1.3rem;\n  font-weight: 600;\n  line-height: 1.3;\n}\n\n.bcc-desc__docs-champ-inner {\n  flex: 1;\n  min-height: 0;\n  overflow: auto;\n  padding: 0 1.25rem 1.125rem;\n  color: #374151;\n  line-height: 1.4;\n  white-space: pre-wrap;\n}\n\n/* Documentation technique (lecture seule) : meme correction d'alignement que la case acheteur\n   (`.bcadm-desc__doc-technique`, DescriptifAdministratifBC.css). Les 3 champs partagent une rangee et\n   « Liste des pièces éventuelles composant la documentation technique » tient sur 2 lignes : sans ca,\n   son cadre descend et se desaligne des deux autres.\n   Classe modificatrice `--doc` : ce fichier compte 5 grilles `.bcc-desc__grid`, seule celle-ci est visee. */\n.bcc-desc__grid--doc {\n  align-items: stretch;\n}\n.bcc-desc__grid--doc .form-group {\n  display: flex;\n  flex-direction: column;\n}\n.bcc-desc__grid--doc .form-group .input-inactif {\n  margin-top: auto;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
